import { LAYOUTS } from "@voltmoney/types";
import SharedPropsService from "../../../SharedPropsService";
import { ROUTE } from "../../../routes";
import { WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { closeModal, goBack, inProgressProcessNavigateAction, navigateToDashboardPage, navigateToReasonPage } from "./action";
import { getContactUsDetails } from "../../../configs/utils";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
export const template = (height, contactUsDetails, getLoanDetails, isFromFaq, isLoanExpired) => ({
    layout: {
        id: ROUTE.FORECLOSURE_NEW,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "foreclosure",
                type: WIDGET.FORECLOSURE_NEW_SCREEN,
            },
        ],
    },
    datastore: {
        foreclosure: {
            height,
            contactUsDetails,
            getLoanDetails,
            isLoanExpired,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.FORECLOSURE_NEW,
                payload: { isFromFaq: isFromFaq }
            },
            navigateToReasonPageAction: {
                type: ACTION.NAVIAGTE_TO_REASON_PAGE,
                routeId: ROUTE.FORECLOSURE_NEW,
            },
            navigateToDashboardPageAction: {
                type: ACTION.NAVIAGTE_TO_DASHBOARD,
                routeId: ROUTE.FORECLOSURE_NEW,
            },
            closeErrorModalAction: {
                type: ACTION.CLOSE_MODAL,
                routeId: ROUTE.FORECLOSURE_NEW,
            },
            inProgressProcessNavigateAction: {
                type: ACTION.INPROGRESS_PROCESS_NAVIGATE,
                routeId: ROUTE.FORECLOSURE_NEW,
            }
        },
    },
});
export const foreclosureScreenMf = {
    onLoad: async ({ instrumentTrack, getHeight, network }, { isFromFaq }) => {
        instrumentTrack('ACCOUNT_CLOSURE_LANDING_PAGE_VIEWED');
        const user = await SharedPropsService.getUser();
        const creditId = user?.linkedCredits[0]?.creditId;
        const contactUsDetails = await getContactUsDetails();
        const isLoanExpired = await SharedPropsService.getIsLoanExpired();
        const getLoanDetails = await network.get(`${api.getLoanDetails}${creditId}`, { headers: await getAppHeader() });
        return Promise.resolve(template(getHeight(), contactUsDetails, getLoanDetails, isFromFaq, isLoanExpired));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NAVIAGTE_TO_REASON_PAGE]: navigateToReasonPage,
        [ACTION.NAVIAGTE_TO_DASHBOARD]: navigateToDashboardPage,
        [ACTION.CLOSE_MODAL]: closeModal,
        [ACTION.INPROGRESS_PROCESS_NAVIGATE]: inProgressProcessNavigateAction,
    },
};
